import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { changeMemoCategory, setTabCategory } from "common/actions";
import { tabColor } from "common/constants/Colors";

class ModalMoveMemo extends React.Component<{
  categories;
  memos;
  memoId;
  changeMemoCategory;
  setTabCategory;
  onClose;
}> {
  componentDidMount() {
    window.addEventListener("keydown", this._keydown);
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this._keydown);
  }

  _keydown = async e => {
    if (e.keyCode === 27) {
      this.props.onClose();
    }
  };

  _onChangeCat = categoryId => {
    this.props.changeMemoCategory({ id: this.props.memoId, categoryId });
    this.props.setTabCategory(categoryId);
    this.props.onClose();
  };

  render() {
    const { categories, memos, memoId } = this.props;
    return (
      <Wrapper>
        <div className="content">
          <h2 className="title">移動先タブ選択</h2>
          <div className="tabs">
            {memoId &&
              categories.order.map((catId, index) => {
                const catName = categories.list[catId].name;
                if (memos[memoId].cat[0] === catId) {
                  return null;
                }
                return (
                  <button
                    key={catId}
                    className="tab"
                    style={{
                      backgroundColor: tabColor[index % tabColor.length]
                    }}
                    onClick={() => this._onChangeCat(catId)}
                  >
                    {catName}
                  </button>
                );
              })}
          </div>
          <button className="close" onClick={() => this.props.onClose()}>
            キャンセル
          </button>
        </div>
      </Wrapper>
    );
  }
}

export default connect(({ categories, memos }) => ({ categories, memos }), {
  changeMemoCategory,
  setTabCategory
})(ModalMoveMemo);

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);

  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar {
    display: none;
  }
  .content {
    background-color: #fff;
    width: 400px;
    margin: 32px auto;
    text-align: center;
    padding: 32px;
    box-sizing: border-box;
    border-radius: 8px;
  }
  .title {
    font-size: 20px;
  }
  .tabs {
    margin: 32px auto;
    width: 300px;
  }
  .tab {
    display: block;
    width: 100%;
    padding: 16px;
    font-size: 16px;
    color: #fff;
    text-align: left;
    border-radius: 2px;
    margin-bottom: 8px;
    position: relative;
  }
  .close {
    background-color: #ddd;
    padding: 8px 16px;
    border-radius: 4px;
  }
`;
